export default __webpack_public_path__ + "static/podcast-react-podcast-bdee9dc1e236588e1ef484875aa21b6e.jpg";